import React, { useState, useEffect } from "react";
import { Redirect, useParams} from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Preloader from "../../../components/Preloader/Preloader";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import Input from '@material-ui/core/Input';
import NumberFormat from 'react-number-format';
const useStyles = makeStyles((theme) => ({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

const BranchPurchaseOrderEncode = (props) => {
    const { recid } = useParams();
	const classes = useStyles();
	//ApiData Component useState SOF
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [branchCurcode, setBranchCurcode] = useState(get_cookies('curcode'));
    const [dataInformation, setdataInformation] = useState({});
    const [newShippingCharge, setNewShippingCharge] = useState("0.00");
    const [totalPayamount, setNewPayamount] = useState("0.00");
    const [totalPayamountDisplay, setNewPayamountDisplay] = useState("0.00");
    const [notes, setNotes] = useState("");
	const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
    };
    // const [itemInformation, setitemInformation] = useState({});
	const get_branchpodetails = () => {
		//get data for warehouse/location dropdown
		const form_data = {
			recid: recid,
            hqidno: branchIdNo
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'branchpodetails';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            setdataInformation(res.data.data_information);
            loadItemtoDatatable(res.data.data_items);
            setNewShippingCharge(res.data.data_information.shippingcost);
            setNewPayamount(res.data.data_information.total);
		});
	};
	//ApiData Component useState EOF
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//Table Settings
	const [TABLE_DATA, loadDataTable] = useState([]);
	const TABLE_COLUMNS = [
		{
		  name: 'itemid',
		  label: 'ID',
		}, 
        {
		  name: 'itemname',
		  label: 'Item Name',
		}, 
        {
            name: 'qty',
            label: 'Qty',
        }, 
        {
            name: 'unit',
            label: 'Unit',
        },
        {
            name: 'price',
            label: 'Price',
        },
        {
            name: 'total',
            label: 'Total',
        }
	];
	
	const TABLE_OPTION = {
		selectableRows: 'none',
		print: false,
		filter: false,
		download: false,
		viewColumns: false,
	};
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	//Modal Settings EOF
    const refreshTable = () => {
        TABLE_DATA.length = 0;
        const newData = [...TABLE_DATA];
		loadDataTable([...newData]);
	}
    
    const loadItemtoDatatable = (itemInformation) =>{
        refreshTable();
		const newData = [...TABLE_DATA];
        for (let i=0;i < itemInformation.length;i++) {
            const tempObj = {
                    itemid:itemInformation[i].itemid, 
                    itemname:itemInformation[i].itemname, 
                    qty:itemInformation[i].qty, 
                    unit:itemInformation[i].unit, 
                    price:itemInformation[i].itemprice,  
                    total:itemInformation[i].totalrow,
                }
            newData.push(tempObj);
        }
        loadDataTable([...newData]);
    }

    const onInputChangeShippingCharge = event => {
        setNewShippingCharge(parseFloat(event.target.value).toFixed(2));
    };

    const onInputChangeNotes = event => {
        setNotes(event.target.value);
    };

    const validateNewShippingCharge = () => {
        if(newShippingCharge == "" || Number(newShippingCharge) == Number(dataInformation.shippingcost)){
            // setShowMsgBox(true);
            // setMsg("No changes Detected");
            // setMsgType("warning");
            setNewShippingCharge(newShippingCharge);
        }else{
            setNewShippingCharge(newShippingCharge);
            setShowMsgBox(true);
            setMsg("Shipping charge updated, but not saved");
            setMsgType("success");
        }
        computeShipping();
        setTimeout(() => {
            setShowMsgBox(false);
            setMsg("");
        }, 3000)
        handleClose();
    }
    
    const computeShipping = () => {
        const totalPayamount2 = totalPayamount.replace(",","");
        const newShippingCharge2 = newShippingCharge.replace(",","");
        let x = Number(parseFloat(totalPayamount2));
        setNewPayamountDisplay(x);
    }

    const submitForm = () => {
        props.history.push(nextpage);
    }
    const nextpage =  {
		pathname: "/sales/branchpopayment",
		dataInformation: dataInformation, // your data array of objects
        itemInformation:TABLE_DATA,
        newShippingCharge:newShippingCharge,
        notes:notes
    }
	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
		isLoggedIn();
        get_branchpodetails();
    }, []);
    useEffect(() => {
		computeShipping();
    }, [totalPayamount]);
    //OnLoad Event/Data Fetching SOF

    //Api Functions SOF
        // Code blocks here
	//Api Request Functions EOF
	//FormData
	const [prep_data, setData] = useState({});
	//FormData EOF
	return (
		!recid ? <Redirect to="/sales" /> :
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/package-sales">
						<h4 className="header-title">Sales</h4>
					</NavLink>
					<Typography color="textPrimary">Branch Purchase Order Details</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
                <form noValidate autoComplete="off">
					<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				    <Grid container spacing={2} alignItems="center" justify="center" className={classes.root}>
					{TABLE_DATA.length == 0? <Preloader/>:<>                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
									<h4 className={classes.title}>Deliver To</h4>
									<h3 className={classes.title}>{dataInformation.customerfullname}</h3>
									<Grid container>
										<Grid item xs={12} sm={6}>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>ID NO.:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{dataInformation.idno}</FormLabel>
												</Grid>
											</Grid>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Date:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{dataInformation.trandate}</FormLabel>
												</Grid>
											</Grid>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Shipping:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{dataInformation.shippingname}</FormLabel>
												</Grid>
											</Grid>
                                            <Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Contact No.:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{dataInformation.contactno}</FormLabel>
												</Grid>
											</Grid>
                                            <Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Address:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{dataInformation.address}</FormLabel>
												</Grid>
											</Grid>
										</Grid>
                                        <Grid item xs={12} sm={6}>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Shipping:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
                                                    <Button 
                                                        variant="contained" 
                                                        color="primary"
                                                        onClick={(e) => {
                                                            handleOpen();
                                                        }}
                                                    >
                                                        {<NumberFormat value={newShippingCharge} displayType={'text'} decimalScale={2} thousandSeparator={true}/>}
                                                    </Button>
												</Grid>
											</Grid>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Total:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel><NumberFormat value={totalPayamountDisplay} displayType={'text'} decimalScale={2} thousandSeparator={true}/></FormLabel>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
                                </CardContent>
                            </Card>
                        </Grid>
						<Grid item xs={12}>
                            <Card>
                                <CardContent>
									<Grid container spacing={2}>
										<Grid item xs={12}>										
											<MUIDataTable
												title={
													<div>
														<div className="table-title">
															Item Details
														</div>
													</div>
												}
												id="table-grid"
												data={TABLE_DATA}
												columns={TABLE_COLUMNS}
												options={TABLE_OPTION}
											/>
										</Grid>
									</Grid>
                                </CardContent>
                            </Card>
                            <Grid item xs={12} style={{marginTop:'10px'}}>
                                <Card>
                                    <CardContent>
                                       <Grid xs={12} sm={12}>
                                            <FormLabel>Notes:</FormLabel>
                                        </Grid>
                                        <Grid xs={12} sm={12}>
                                            <TextField
                                                style={{width: '100%'}}
                                                placeholder="Notes..."
                                                multiline
                                                rows={2}
                                                col={12}
                                                rowsMax={4}
                                                value={notes}
                                                onChange={onInputChangeNotes}
                                            />
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>  
                        </Grid>
                        <Grid item xs="12" className={classes.buttonContainer}>
							<Button 
								variant="contained" 
								color="primary"
                                onClick={submitForm}
							>
								Proceed
							</Button>
                        </Grid></>}

                    </Grid>
					<div>
						<Modal
							aria-labelledby="transition-modal-title"
							aria-describedby="transition-modal-description"
							className={classes.modal}
							open={open}
							onClose={handleClose}
							closeAfterTransition
							BackdropComponent={Backdrop}
							BackdropProps={{
								timeout: 500,
							}}
						>
							<Fade in={open}>
								<div className={classes.paper}>
									<h4 id="transition-modal-title">Update Shipping Charge</h4>
									<form action="" className={classes.root}>
										<Grid container spacing={3}>
											<Grid item xs={3}>
												Shipping
											</Grid>
											<Grid item xs={9}>
												<TextField
													type="number"
													required
													name="updatedshippingcharge"
													label="Shipping Charge"
													variant="outlined"
                                                    onChange={onInputChangeShippingCharge}
												/>
											</Grid>
										</Grid>
										<div className={classes.button}>
											<Button
												variant="contained"
												onClick={handleClose}
												className={classes.buttonMarginRight}
											>
												Close
											</Button>
											<Button 
												variant="contained" 
												color="primary"
                                                onClick={(e) => {
                                                    validateNewShippingCharge();
                                                }}
											>
												Update Shipping Charge
											</Button>
										</div>
									</form>
								</div>
							</Fade>
						</Modal>
					</div>
                </form>
			</div>
		</div>
	);
};

export default BranchPurchaseOrderEncode;
